// extracted by mini-css-extract-plugin
export var truncate = "_8-0";